// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table {
  margin-bottom: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/additional-content/additional-content-list/additional-content-group/additional-content-group.component.scss"],"names":[],"mappings":"AAAA;EACI,2BAAA;AACJ","sourcesContent":["table {\n    margin-bottom: 0 !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
